import React, { useEffect } from "react";
import { Button, Modal } from "antd";
import { useTranslation } from "react-i18next";
import User from "../../assets/icons/user-calling.svg";
import { PHONE_STATES } from "../../constants/system.keys";
import CountUpTimer from "./CountUpTimer";

const InCallingPopup = ({ visible, onCancel, status, phoneNumber }) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (status === PHONE_STATES.TERMINATED || status === PHONE_STATES.REJECTED) {
      onCancel();
    }
  }, [status]);

  return (
    <Modal
      title={null}
      centered
      visible={visible}
      width="20%"
      footer={false}
      maskClosable={false}
      getContainer={() => document.getElementById('main-live-page')}
    >
      <div style={{ textAlign: "center" }} className="in-calling">
        <div>
          <img src={User} alt="user"/>
        </div>
        {
          status !== PHONE_STATES.IN_CALL && (
            <div style={{ textAlign: "center" }}>{t('Calling...')}</div>
          )
        }
        {
          (status === PHONE_STATES.CALLING_OUT) && (
            <div>
              <div style={{ fontWeight: "bold", fontSize: "18px" }}>{phoneNumber}</div>
              <Button onClick={onCancel} type="primary" danger>{t('End')}</Button>
            </div>
          )
        }
        {
          (status === PHONE_STATES.IN_CALL) && (
            <div style={{ marginTop: "12px" }}>
              <div style={{ fontWeight: "bold", fontSize: "18px" }}>{phoneNumber}</div>
              <CountUpTimer  />
              <Button onClick={onCancel} type="primary" danger>{t('End')}</Button>
            </div>
          )
        }
      </div>
    </Modal>
  )
}

export default InCallingPopup;